import { render, staticRenderFns } from "./App.vue?vue&type=template&id=fec8f746&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fec8f746')) {
      api.createRecord('fec8f746', component.options)
    } else {
      api.reload('fec8f746', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=fec8f746&", function () {
      api.rerender('fec8f746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/App.vue"
export default component.exports